// @flow
import { toast } from 'react-toastify'
import type { ToastOptions, ToastContent } from 'react-toastify'
import { rawMarkup } from '@foxford/foxford-utils'
import css from './animation.sass'

/*
  Штука для показа уведомлений.

  Использовать так:
  import { notifications } from 'utils/notifications'

  notifications.error('text or <b>html</b>')
  isNode параметр если нужно прокинуть node-component
 */

const idsMap: { [ToastContent]: number | string } = {}
let idsCounter = 0
const timeoutMap: { [ToastContent]: TimeoutID } = {}

const showToast = (
  typedToast: typeof toast,
  content: ToastContent,
  isNode: boolean = false,
  params?: ToastOptions = {}
) => {
  const key = params.toastId === undefined ? content : params.toastId
  const toastId = idsMap[key]

  if (!toast.isActive(toastId)) {
    const cnt = isNode ? content : <span dangerouslySetInnerHTML={rawMarkup(content)} />

    idsMap[key] = typedToast(cnt, params)

    // clear map
    if (idsCounter > 50) {
      idsCounter = 0
      Object.keys(idsMap).forEach((mapKey) => {
        if (toast.isActive(idsMap[mapKey])) {
          idsCounter++
        } else {
          delete idsMap[mapKey]
        }
      })
    } else {
      idsCounter++
    }
  } else if (timeoutMap[toastId] === undefined) {
    // start animation if notification already shown and not animated yet
    toast.update(toastId, {
      className: css.shake,
    })

    // clear animation class
    timeoutMap[toastId] = setTimeout(() => {
      toast.update(toastId, {
        className: css.none,
      })
      delete timeoutMap[toastId]
    }, 800)
  }
}

const notifications = {
  error: (content: ToastContent, isNode: boolean = false, params?: ToastOptions = {}) => {
    showToast(toast.error, content, isNode, params)
  },
  warning: (content: ToastContent, isNode: boolean = false, params?: ToastOptions = {}) => {
    showToast(toast.warn, content, isNode, params)
  },
  info: (content: ToastContent, isNode: boolean = false, params?: ToastOptions = {}) => {
    showToast(toast.info, content, isNode, params)
  },
  success: (content: ToastContent, isNode: boolean = false, params?: ToastOptions = {}) => {
    showToast(toast.success, content, isNode, params)
  },
  custom: (content: ToastContent, isNode: boolean = false, params?: ToastOptions = {}) => {
    const cnt = isNode ? content : <span dangerouslySetInnerHTML={rawMarkup(content)} />

    toast(cnt, params)
  },
  dismiss: toast.dismiss,
}

window.notify = notifications

export { notifications, notifications as notify }
